/* eslint-disable camelcase */
import type { AccountId } from '@hotjar/account';
import type { OrganizationId } from '@hotjar/organization';
import type { UserId } from '@hotjar/user';
import type { SiteId } from '@hotjar/site';

export enum USER_EXPERTISE {
  'BEGINNER' = 'beginner',
  'INTERMEDIATE' = 'intermediate',
  'EXPERT' = 'expert',
  'SKIP' = 'skip',
}

export enum USER_GOALS {
  'FEEDBACK' = 'feedback',
  'HEATMAPS' = 'heatmaps',
  'RECORDINGS' = 'recordings',
  'SURVEYS' = 'surveys',
  'SKIPPED' = 'skipped',
}

export interface UserPersonalizationInfoDto {
  account_id: AccountId;
  expertise: USER_EXPERTISE | undefined;
  goal: USER_GOALS | undefined;
  organization_id: OrganizationId;
  role: string;
  site_id: SiteId;
  user_id: UserId;
}

export interface UserPersonalizationInfo {
  accountId: AccountId;
  expertise: USER_EXPERTISE | undefined;
  goal: USER_GOALS | undefined;
  organizationId: OrganizationId;
  role: string;
  siteId: SiteId;
  userId: UserId;
}
